import { Contact } from "@/components/Contact";

/** The intake, on its own page. The footer hides its closing ask here. */
export default function ContactPage() {
  return (
    <main
      className="bg-cream text-ink no-x pt-[76px]"
      data-testid="contact-page"
    >
      <Contact />
    </main>
  );
}
